define('controller/step/datetime/SlotsWeeklyDateTimeStep',['require','controller/step/datetime/BaseWeeklyDateTimeStep','collection/TimeSlotCollection','view/controller/booking/datetime/slots-weekly/TimeSlotsWeeklyView'],function (require) {

    var BaseWeeklyDateTimeStep = require('controller/step/datetime/BaseWeeklyDateTimeStep');
    var TimeSlotCollection = require('collection/TimeSlotCollection');
    var TimeSlotsWeeklyView = require('view/controller/booking/datetime/slots-weekly/TimeSlotsWeeklyView');

    return BaseWeeklyDateTimeStep.extend({

        _timeCollection: null,

        /**
         * Inits time collection
         */
        _initTimeCollection: function () {
            this._timeCollection = new TimeSlotCollection();
        },

        /**
         * Returns time view
         *
         * @return TimeFlexibleView
         */
        _getTimeView: function () {
            var view = new TimeSlotsWeeklyView({
                model: this._bookingModel,
                bookingModel: this._bookingModel,
                timeCollection: this._timeCollection,
                calendarCollection: this._calendarCollection,
                timeValidateModel: this._timeValidateModel,
                clientTimeZone: this.getOption('clientTimeZone'),
                showNavigation: this._supportsTimelineNavigation,
                waitingListHelperModel: this.getOption('waitingListHelperModel'),
            });
            
            this.listenTo(view, 'timeChanged', this._updateSelectedTime);

            return view;
        }

    });

});
